import { createFileRoute } from "@tanstack/react-router"

import { issueTypeIdentifiersViewStaticData } from "../../../../../../../../views/IssueTypeSettingsIdentifiersView/constants"
import { IssueTypeSettingsIdentifiersView } from "../../../../../../../../views/IssueTypeSettingsIdentifiersView/IssueTypeSettingsIdentifierView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/identifiers",
)({
	component: IssueTypeSettingsIdentifiersView,
	staticData: issueTypeIdentifiersViewStaticData,
})
